<script lang="ts">
    import {ApiCall} from "../../services/ApiCall.ts";
    import {push} from "svelte-spa-router";
    import Modal from "../Modal/Modal.svelte";

    let promise = makeApiCall();

    async function makeApiCall() {

        const apiCall = new ApiCall();

        try{
            const content = await apiCall.authenticatedPostRequest('applicateur/get_documentation', null);

            if (content.success === false) {
                push('/erreur500')
            }
            else{
                content.data.forEach(element =>
                    element['created_at'] = new Date(element['created_at']).toLocaleString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'})
                );

                return content.data;
            }
        }
        catch (e) {
            push('/erreur500')
        }
    }
    let downloadPromise;
    function preDownload(fileId, fileName) {

        downloadPromise = downloadFile(fileId, fileName);
    }

    async function downloadFile(fileId, fileName) {

        let documentToDownload = {file_id: fileId}

        const apiCall = new ApiCall();

        try {
            const content = await apiCall.downloadPostRequest('applicateur/download_documentation', documentToDownload);

            const documentBlob  =  await content.blob()
            const documentURL = URL.createObjectURL(documentBlob)

            const anchor = document.createElement('a');
            anchor.href = documentURL;
            anchor.download = fileName;

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            URL.revokeObjectURL(documentURL);
        }
        catch (e) {
            push('/erreur500')
        }
    }

</script>

<h2 class="title is-2 has-text-centered mb-6">Documentations</h2>
{#await downloadPromise}
    <Modal title="Préparation du téléchargement" type="loader"/>
{/await}

{#await promise}
    <Modal title="Chargement des documents" type="loader"/>
{:then allDocuments}
    {#if allDocuments.length > 0}
        {#each allDocuments as {id, filename, original_filename}}
            <div class="box mb-6">
                <div class="box-content">
                    <div class="is-flex is-justify-content-space-around is-align-content-center columns">
                        <p class="column is-flex is-align-items-center">
                            <strong>{original_filename}</strong>
                        </p>
                        <div class="column is-flex is-justify-content-flex-end is-align-items-center">
                            <button class="button download-button" on:click={() => preDownload(id, original_filename)}>Télécharger</button>
                        </div>
                    </div>
                </div>
            </div>
        {:else}
            <Modal title="Chargement des documents">
                <svelte:fragment slot="content">
                    <div class="dots6">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </svelte:fragment>
            </Modal>
        {/each}
    {:else }
        <div class="box">
            <div class="box-header is-flex is-justify-content-center">
                <p>Vous retrouverez prochainement de la documentation dans cette section.</p>
            </div>
        </div>
    {/if}
{/await}